import React from "react";
import { string, oneOfType, arrayOf, node } from "prop-types";
import "./style.css";

RoundIcon.propTypes = {
  color: string,
  noFlag: string,
  noDoc: string,
  children: oneOfType([arrayOf(node), node]),
};

function RoundIcon({ color, children, noFlag, noDoc }) {
  return (
     <div
      className={`round-icon round-icon-${color} noFlag-${noFlag} noDoc-${noDoc}`}
    >
      {children}
    </div>
  );
}

export default RoundIcon;
